'use strict';
import Api from '../abstract';

export let VERIFY_USER = (params, successCallback, errorCallback) => {
    let url = `/user/auth/verify`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let VERIFY_EMAIL_LOGIN = (params, successCallback, errorCallback) => {
    let url = `/user/auth/verify-email-login/${params.payload.email}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let AUTH_LOGIN = (params, successCallback, errorCallback) => {
    let url = `/user/auth/login`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let AUTH_LOGIN_OTP = (params, successCallback, errorCallback) => {
    let url = `/user/auth/login/otp`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let AUTH_RESEND_LOGIN_OTP = (params, successCallback, errorCallback) => {
    let url = `/user/auth/login/otp`;
    let data = params.payload.data;
    return Api.patch(url, data).then(successCallback).catch(errorCallback);
};

export let AUTH_LOGOUT = (params, successCallback, errorCallback) => {
    let url = `/user/auth/logout`;
    return Api.post(url).then(successCallback).catch(errorCallback);
};

export let FORGOT_PASSWORD = (params, successCallback, errorCallback) => {
    let url = `/user/auth/forgot-password`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let CHANGE_PASSWORD = (params, successCallback, errorCallback) => {
    let url = `/user/auth/reset-password`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let VERIFY_SETTING_PASSWORD = (params, successCallback, errorCallback) => {
    let url = `/user/auth/setting-password/verify/${params.payload.token}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let ADD_PASSWORD_USER = (params, successCallback, errorCallback) => {
    let url = `/user/auth/setting-password`;
    let data = params.payload.data;
    return Api.patch(url, data).then(successCallback).catch(errorCallback);
};
